import EventEmitter from 'eventemitter3';
import LaravelResponseUnwrapper from '../../networking/response/LaravelResponseUnwrapper';
import { createRequester } from '../../networking';
import { createRoutingConfig } from '../../routing';
import { createTranslator } from '../../localization';
import LocalStore from '../store/LocalStore';
import SessionStore from '../store/SessionStore';
export var AppEnv;
(function (AppEnv) {
    AppEnv[AppEnv["PROD"] = 0] = "PROD";
    AppEnv[AppEnv["DEV"] = 1] = "DEV";
})(AppEnv || (AppEnv = {}));
var BuroApp = /** @class */ (function () {
    function BuroApp() {
        /**
         * Strategy for extracting data from an API response
         *
         * @private
         */
        this._unwrapStrategy = new LaravelResponseUnwrapper();
        /**
         * Requester with a set baseURL and HttpFilters for making requests
         *
         * @private
         */
        this._requester = createRequester({ baseUrl: '', httpFilters: [] });
        /**
         * Configuration object for the application's routing
         */
        this._routingConfig = createRoutingConfig([]);
        /**
         * The environment the application is running in
         */
        this._env = AppEnv.PROD;
        this._eventEmitter = new EventEmitter();
        /**
         * Local and session storage
         * @private
         */
        this._localStorage = new LocalStore();
        this._sessionStorage = new SessionStore();
    }
    /**
     * Validates all configurations and loads the stores
     */
    BuroApp.prototype.init = function () {
        this._localStorage.load();
        this._sessionStorage.load();
    };
    Object.defineProperty(BuroApp.prototype, "translator", {
        get: function () {
            if (!this._translator)
                throw 'Translator not set!';
            return this._translator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "unwrapStrategy", {
        get: function () {
            return this._unwrapStrategy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "requester", {
        get: function () {
            return this._requester;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "routingConfig", {
        get: function () {
            return this._routingConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "localStorage", {
        get: function () {
            return this._localStorage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "sessionStorage", {
        get: function () {
            return this._sessionStorage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "isProd", {
        get: function () {
            return this._env === AppEnv.PROD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuroApp.prototype, "isDev", {
        get: function () {
            return this._env === AppEnv.DEV;
        },
        enumerable: false,
        configurable: true
    });
    /** Events */
    BuroApp.prototype.onEvent = function (event, fn) {
        this._eventEmitter.on(event, fn);
    };
    BuroApp.prototype.onEventOnce = function (event, fn) {
        this._eventEmitter.once(event, fn);
    };
    BuroApp.prototype.emitEvent = function (event, payload) {
        this._eventEmitter.emit(event, payload);
    };
    BuroApp.prototype.removeEvent = function (event, fn) {
        this._eventEmitter.off(event, fn);
    };
    BuroApp.prototype.setupTranslator = function (translations) {
        this._translator = createTranslator(translations);
    };
    BuroApp.prototype.setupUnwrapStrategy = function (value) {
        this._unwrapStrategy = value;
    };
    BuroApp.prototype.setupRequester = function (baseUrl, httpFilters) {
        this._requester = createRequester({ baseUrl: baseUrl, httpFilters: httpFilters });
    };
    BuroApp.prototype.setupRoutingConfig = function (config) {
        this._routingConfig = config;
    };
    BuroApp.prototype.setEnv = function (env) {
        this._env = env;
    };
    return BuroApp;
}());
export { BuroApp };
export default BuroApp;
